import axios from 'axios'
import store from '../../store/index'

const state = {
  locations: [],
  location: {},
}

const mutations = {
  locations_data (state, locations) {
    state.locations = locations
  },
  location_data (state, location) {
    state.location = location
  },
}

const actions = {
  getLocations ({ commit }, type) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations/list?type=' + type,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('locations_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getLocation ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations?id=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('location_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  createLocation ({ commit }, location) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations',
        data: location,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateLocation ({ commit }, location) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations',
        data: location,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteLocation ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations?id=' + locationId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  toggleLocationArchive ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations/toggleArchive?id=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  duplicateLocation ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locations/dublicate?id=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
